import AxiosInstance from "@/api";
import { API_ROUTES } from "@/constants/api-routes";
import {
    IGetCurrencyExchangeResponse,
    IGetHomeCategorySelectorResponse,
    IUpdateCurrencyExchangePayload,
    IUpdateCurrencyExchangeResponse,
    IUpdateHomeCategorySelectorPayload,
    IUpdateHomeCategorySelectorResponse,
} from "@/api/types/system-settings";

export const GetCurrencyExchangeSettings = async () => {
    const result = await AxiosInstance.get<IGetCurrencyExchangeResponse>(API_ROUTES.SYSTEM_SETTINGS.CURRENCY_EXCHANGE);
    return result.data;
};

export const UpdateCurrencyExchangeSettings = async (body: IUpdateCurrencyExchangePayload) => {
    const result = await AxiosInstance.put<IUpdateCurrencyExchangeResponse>(
        API_ROUTES.SYSTEM_SETTINGS.CURRENCY_EXCHANGE,
        body
    );
    return result.data;
};

export const GetHomeCategorySelectorSettings = async () => {
    const result = await AxiosInstance.get<IGetHomeCategorySelectorResponse>(
        API_ROUTES.SYSTEM_SETTINGS.HOME_CATEGORY_SELECTOR
    );
    return result.data;
};

export const UpdateHomeCategorySelectorSettings = async (body: IUpdateHomeCategorySelectorPayload) => {
    const result = await AxiosInstance.put<IUpdateHomeCategorySelectorResponse>(
        API_ROUTES.SYSTEM_SETTINGS.HOME_CATEGORY_SELECTOR,
        body
    );
    return result.data;
};
